import firebase from './init'
import { NotificationsT } from 'types/notifications'
import { captureSentryError } from '../services/sentry'

let notifications: NotificationsT = []
let notificationsCallback: (notifications: NotificationsT) => void = () => {}

export const notificationsSubscription = callback => {
    notificationsCallback = callback
}

export const subscribeForNotifications = uid => {
    const query = firebase
        .firestore()
        .collection('notifications')
        .where('uid', '==', uid)

    return query.onSnapshot(
        async querySnapshot => {
            notifications = (await Promise.all(
                querySnapshot.docs.map(doc => doc.data())
            )) as NotificationsT
            notificationsCallback(notifications)
        },
        err => {
            captureSentryError(err)
            notificationsCallback([])
        }
    )
}

export const getNotifications = () => {
    return notifications
}
